<template>
  <van-dialog class="bdc-dialog"
              ref="dialog"
              :is-disable-close="true"
              :is-show-footer="!isExam">
    <template slot="title">
      <van-quizzes-toolbar :title="navigation" :is-forced="false" @close="close" />
    </template>
    <div class="bdc-dialog-wrap"  ref="wrap">
      <div class="ready" v-if="isSceneReady">
        <h1>{{ title }}</h1>
        <br />
        <h2 v-html="subtitle"></h2>
        <h3 class="description" v-html="description"></h3>
        <br />
        <div class="btn-control">
          <el-button v-if="quizzes.length" type="primary" @click="scene = 2">
            <template v-if="isExam">
              <template v-if="isLearnBeforeTest || isLearnAfterTest">开始测试</template>
              <template v-else>开始考试</template>
            </template>
            <template v-else>{{quizType === 'active_review ' ? '开始复习' : '开始学习'}}</template>
          </el-button>
          <el-button type="danger" v-if="isLearnBeforeTest" @click="skipBeforeTest">放弃测试</el-button>
        </div>
      </div>
      <template v-else-if="isScenePlaying">
        <van-exam
          v-if="isExam"
          :exercises="newQuizzes"
          :quiz-type="quizType"
          :mode="examType"
          :course-id="courseId"
          :unit-id="unitId"
          :name="navigation"
          @continue="continueLearning({ scene: 1 })"
          @finished="close"
          @submitted="submittedExam"
          @openCertificate="openCertificate"
          @learnNext="learnNext"
        />
        <van-quizzes-controller
            v-else
            ref="controller"
            :exercises="newQuizzes"
            :is-exam="isExam"
            :is-show-speaker="!!(currentExercise.code !== 'DCPX' && this.currentExercise.audio)"
            :is-show-hint="!isExam"
            :quiz-type="quizType"
            :book-mode="bookMode"
            :exam-results="results"
            :user-answer="userAnswer"
            @exercise-change="exerciseChange"
            @change="change"
            @finish="finish"
            @submit="submitResult" />
      </template>
      <div class="finished" v-else-if="scene === 3">
        <div class="flex-wrap" v-if="isLearnAfterTest || isLearnBeforeTest">
          <van-exam
            :exercises="newQuizzes"
            :extend="{results, score, response}"
            :name="navigation"
            :quiz-type="quizType"
            is-preview
            @openCertificate="openCertificate"
            @learnNext="learnNext"
          >
            <template slot="control" v-if="isLearnAfterTest">
              <el-button type="primary" @click="replay('wrongs')" v-if="isHasWrongs">
                错题再练
              </el-button>
              <el-button type="primary" @click="close">完成</el-button>
            </template>
            <template slot="control" v-if="isLearnBeforeTest">
              <el-button type="primary" @click="continueLearning({ scene: 1 })">继续学习</el-button>
            </template>
            <template slot="before-exam-tips">
              <span class="tips" v-html="message"></span>
            </template>
          </van-exam>
        </div>
        <div class="flex-wrap" v-else>
          <h1>{{ title }}</h1>
          <h2>
            <template
              v-if="!bookReview && quizType === 'learn'
              && progress !== 100">太棒了！</template>
            <template v-else-if="
              !bookReview
              && quizType === 'learn'
              && progress === 100">
              你已完成本单元学习，需要进行本单元整体复习吗？
            </template>
            <template v-else-if="bookReview">
              太棒了！你已完成本书{{bookReview === 'book_half_push' ? '一半' : '全部'}}内容，可以对已学单元进行整体复习哦！
            </template>
            <template v-else-if="quizType === 'active_review'
              || quizType === 'force'
              || quizType === 'all_book'
              || quizType === 'half_book'">好棒！温故而知新，坚持下去你真的会变成学霸哦！</template>
            <template v-else-if="quizType === 'student_wrong'">恭喜你完成本次易错词的强化训练。</template>
            <template v-else-if="quizType === 'book_one_side'">太牛了！你离学霸之路越来越近啦！</template>
          </h2>
          <h3 class="description" v-html="message">
          </h3>
          <div class="btn-control">
            <template v-if="bookReview">
              <el-button type="primary" @click="startReview('bdc_book_review')">开始复习</el-button>
              <el-button type="danger" @click="close">暂不复习</el-button>
            </template>
            <template v-else-if="!bookReview && quizType === 'learn' && progress !== 100">
              <el-button type="primary" @click="continueLearning">再来一组</el-button>
            </template>
            <template v-else-if="
              !bookReview
              && quizType === 'learn'
              && progress === 100">
                <el-button type="primary" @click="startReview('bdc_review')">开始复习</el-button>
                <el-button type="danger" @click="close">退出</el-button>
            </template>
            <template v-else-if="
              !bookReview
              && quizType === 'force'">
                <el-button type="primary" @click="continueLearning({ scene: 1 })">开始新学</el-button>
            </template>
            <template v-else>
              <el-button type="danger" @click="close">退出</el-button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import { Button } from 'element-ui';
import utils from '@/services/utils';
import VanDialog from '@/components/common/Dialog.vue';
import VanQuizzesToolbar from '@/components/quizzes/QuizzesToolbar.vue';
import VanQuizzesController from '@/components/quizzes/bdc/Quizzes.vue';
import VanExam from '@/components/quizzes/bdc/Exam.vue';
import api from '@/api/graphql/englishCourse';

const SCENE = Object.freeze({
  ready: 1,
  playing: 2,
  finished: 3,
});

export default {
  components: {
    ElButton: Button,
    VanQuizzesToolbar,
    VanDialog,
    VanQuizzesController,
    VanExam,
  },
  props: {
    unitId: {
      type: Number,
      default: -1,
    },
    isExam: {
      type: Boolean,
      default: false,
    },
    examType: {
      type: String,
      default: '',
    },
    navigation: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    quizType: {
      type: String,
      default: 'learn',
    },
    quizzes: {
      type: Array,
      default: () => ([]),
    },
    bookMode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      scene: SCENE.ready,
      score: 0,
      results: [],
      exerciseIndex: 0,
      seconds: 0,
      bookReview: '', // 是否是本书复习
      progress: 0, // 完成率
      isComplete: false,
      newQuizzes: [],
      message: '',
      response: null,
    };
  },
  watch: {
    quizzes() {
      this.newQuizzes = this.quizzes.map((item, index) => ({
        ...item,
        index,
        errorCount: 0,
        spendTime: 0,
        isRight: false,
        userAnswer: null,
        isComplete: false,
      }));
      this.results = this.quizzes.map((item, index) => ({
        ...item,
        index,
        isRight: false,
        userAnswer: null,
        isComplete: false,
      }));
    },
  },
  computed: {
    courseId() {
      return Number(this.$route.params.courseId) || 0;
    },
    isSceneReady() {
      return this.scene === SCENE.ready;
    },
    isScenePlaying() {
      return this.scene === SCENE.playing;
    },
    currentExercise() {
      return this.newQuizzes[this.exerciseIndex];
    },
    userAnswer() {
      return this.results[this.exerciseIndex].userAnswer || null;
    },
    isLearnBeforeTest() {
      return this.quizType === 'learn_before_test';
    },
    isLearnAfterTest() {
      return this.quizType === 'learn_after_test';
    },
    isHasWrongs() {
      return this.results.some(result => !result.isRight);
    },
    isArticleExam() {
      return this.newQuizzes.every(item => item.code === 'YDLJ');
    },
  },
  methods: {
    disableCopy() {
      const el = document.querySelector('.bdc-dialog');
      el.oncontextmenu = (e) => {
        e.preventDefault();
      };

      el.onselectstart = (e) => {
        e.preventDefault();
      };

      el.oncopy = (e) => {
        e.preventDefault();
      };

      el.onkeydown = e => !(e.ctrlKey || e.ctrlKey || e.shiftKey);
    },
    openCertificate({ response, results }) {
      this.$emit('refresh');
      this.$emit('show-report', {
        response,
        results,
      });
    },
    open() {
      this.reset();
      this.$nextTick(() => {
        this.bindEnterEvent();
      });
      this.$refs.dialog.open();
    },
    close() {
      if (this.bookReview) {
        const type = this.bookReview === 'book_half_push' ? 'bdc_half_book' : 'bdc_all_book';
        api.submitCourseResult({
          courseId: this.courseId,
          unitId: this.unitId,
          type,
          mode: this.examType,
          spend: [],
          quizzes: [],
        }).then(() => {});
      }
      this.unBindEnterEvent();
      this.reset();
      this.$refs.dialog.close();
      this.$emit('close');
    },
    reset(scene) {
      this.exerciseIndex = 0;
      this.results = [];
      this.isComplete = false;
      this.bookReview = '';
      this.scene = scene || SCENE.ready;
    },
    continueLearning({ scene = '' } = {}) {
      this.reset();
      this.$emit('continue', 'bdc_learn', scene);
    },
    startReview(type) {
      this.reset();
      this.$emit('continue', type);
    },
    finish(payload) {
      this.submitResult(payload);
    },
    submitResult(payload) {
      api.submitCourseResult({
        courseId: this.courseId,
        unitId: this.unitId,
        type: `bdc_${this.quizType}`,
        mode: this.examType,
        seconds: 0,
        spend: JSON.stringify(payload.spend),
        quizzes: payload.results,
      }).then(({ englishCourseResult }) => {
        this.bookReview = englishCourseResult.bookReview;
        this.progress = englishCourseResult.progress;
        this.message = englishCourseResult.message;
        if (this.bookReview === 'learn_after_test') {
          this.continueLearning({
            scene: SCENE.ready,
          });
        } else {
          this.scene = SCENE.finished;
        }
        this.$emit('refresh');
      }).catch(() => {
        this.close();
      });
    },
    skipBeforeTest() {
      utils.confirm('确定要放弃学前测试吗？放弃的话成绩会是0分哦！', '放弃测试')
        .then(() => {
          api.submitCourseResult({
            courseId: this.courseId,
            unitId: this.unitId,
            type: `bdc_${this.quizType}`,
            mode: this.examType,
            seconds: 0,
            spend: '',
            quizzes: this.newQuizzes.map(quiz => ({
              id: quiz.id,
              status: 0,
              errorCount: 1,
              answer: JSON.stringify([{
                code: quiz.code,
                mode: quiz.mode,
                userAnswer: '',
              }]),
            })),
          })
            .then(({ englishCourseResult: response }) => {
              this.submittedExam({
                score: 0,
                results: this.newQuizzes.map((quiz, index) => ({
                  id: quiz.id,
                  answer: '',
                  isRight: false,
                  isComplete: false,
                  key: `${quiz.id}_${quiz.code}_${quiz.mode}`,
                  ref: quiz,
                  index,
                })),
                response,
              });
            });
        });
    },
    submittedExam({
      score,
      results,
      response,
      isArticleExam,
    } = {}) {
      /* eslint-disable no-lonely-if */
      this.$emit('refresh');
      if (score >= 100 && this.quizType === 'learn_after_test') {
        this.close();
        this.$emit('show-report', {
          response,
          results,
        });
      } else {
        if (this.isLearnBeforeTest || this.isLearnAfterTest) {
          if (isArticleExam || this.isArticleExam) {
            if (this.isLearnBeforeTest) {
              this.continueLearning({ scene: 1 });
            } else {
              this.close();
            }
            return;
          }
          this.newQuizzes = results.map(result => ({
            ...result.ref,
            userAnswer: result.answer,
          }));
          this.message = response.message.replace(/(\d+)/, '<span>$1</span>');
          this.results = results;
          this.score = score;
          this.scene = SCENE.finished;
          this.response = response;
        }
      }
    },
    replay(type) {
      let quizzes;
      if (type === 'wrongs') {
        quizzes = this.results.filter(result => !result.isRight)
          .map(result => ({
            ...result.ref,
            userAnswer: result.answer,
          }));
      }
      this.$emit('replay', {
        quizzes,
        type,
      });
    },
    exerciseChange({ exerciseIndex }) {
      // when isExam is true 生效
      this.exerciseIndex = exerciseIndex;
    },
    change(payload) {
      this.results.forEach((item) => {
        if (item.id === payload.id && item.code === payload.code && item.mode === payload.mode) {
          item.isRight = payload.isRight;
          item.isComplete = payload.isComplete;
          item.userAnswer = payload.userAnswer;
        }
      });
    },
    handleSubmitExamBtn() {
      this.$refs.controller.submit();
      this.scene = SCENE.finished;
    },
    handleGlobalEnter(event) {
      if (this.isSceneReady && event.keyCode === 13) {
        this.scene = SCENE.playing;
      }
    },
    bindEnterEvent() {
      document.addEventListener('keyup', this.handleGlobalEnter);
    },
    unBindEnterEvent() {
      document.removeEventListener('keyup', this.handleGlobalEnter);
    },
    learnNext() {
      this.$emit('refresh', {
        callback: () => {
          this.continueLearning({ scene: 1 });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/tip-line.scss';

  .bdc-dialog {
    user-select: none;
    .bdc-dialog-wrap {
      box-sizing: border-box;
      height: 736px;
      overflow-y: auto;
      /*display: flex;*/
      /*flex-direction: column;*/
      /*justify-content: center;*/
      // padding-bottom: 65px;
      .ready {
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .description {
          span {
            color: $primary;
          }
        }
        .el-button {
          min-width: 120px;
        }
      }
      .time {
        position: absolute;
        top: 10px;
        right: 0;
        transform: translateX(-50%);
        font-size: 22px;
        color: $primary;
      }
      .finished {
        height: 100%;
        .flex-wrap {
          height: 100%;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .btn-control {
            margin-top: 70px;
          }
          .description {
            span {
              color: $primary;
            }
          }
        }
      }
      .tip-line {
        margin-top: 20px;
      }
      .exam-control {
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        padding: 5px 20px;
        width: 100%;
      }
      .btn-control {
        .el-button {
          margin: 0 30px;
          min-width: 120px;
        }
      }
    }
    /deep/ .el-dialog {
      width: 1400px!important;
      height: 788px!important;
      max-height: 788px;
      .el-dialog__body {
        .content {
          padding: 0!important;
        }
      }
      .el-dialog__footer {
        padding: 5px 20px;
        border: 0;
        .dialog-footer {
          min-height: 55px;
        }
      }
    }
  }
  @media screen and (max-device-height: 1079px){
    .bdc-dialog {
      .bdc-dialog-wrap {
        height: 510px!important;
        .table-wrap {
          height: 220px!important;
        }
      }
      /deep/ .el-dialog {
        width: 1250px!important;
        height: 563px!important;
        .el-dialog__body {
          .content {
            padding: 0;
          }
        }
        .el-dialog__footer {
          padding: 5px 20px;
          border: 0;
          .dialog-footer {
            min-height: 55px;
          }
        }
      }
    }
  }
</style>
